import React from 'react'
import { Route } from 'react-router-dom'
import AppUrls from 'parts/constants/pageUrl'
import LoginPage from 'pages/auth/pages/login/LoginPage/LoginPage'
import ErrorPage from 'pages/duty/ErrorPage/ErrorPage'
import { RouterVarNames } from 'parts/constants/routerVarNames'
import lazyPage from './lazyPage'

// Страница входа и страница ошибки остаются в главном бандле: вход — самая
// частая точка входа в приложение, ErrorPage используется как fallback
// у Sentry.ErrorBoundary. Остальные страницы авторизации грузятся по требованию.
const MagicLinkPage = lazyPage(
	() => import('pages/auth/pages/magicLink/MagicLinkPage/MagicLinkPage')
)
const RecoveryCheckPage = lazyPage(
	() =>
		import(
			'pages/auth/pages/recovery/recoveryCheck/RecoveryCheckPage/RecoveryCheckPage'
		)
)
const RecoverySetPage = lazyPage(
	() =>
		import(
			'pages/auth/pages/recovery/recoverySet/RecoverySetPage/RecoverySetPage'
		)
)
const RecoverStartPage = lazyPage(
	() =>
		import(
			'pages/auth/pages/recovery/recoveryStart/RecoveryStartPage/RecoverStartPage'
		)
)
const RecoveryFinishPage = lazyPage(
	() =>
		import(
			'pages/auth/pages/recovery/recoveryFinish/RecoveryFinishPage/RecoveryFinishPage'
		)
)
const DeleteAccountPage = lazyPage(
	() =>
		import(
			'pages/auth/pages/deleteAccount/DeleteAccountPage/DeleteAccountPage'
		)
)
const DeleteAccountConfirmPage = lazyPage(
	() =>
		import(
			'pages/auth/pages/deleteAccount/DeleteAccountConfirm/DeleteAccountConfirmPage'
		)
)
const DeleteAccountDonePage = lazyPage(
	() =>
		import(
			'pages/auth/pages/deleteAccount/DeleteAccountDone/DeleteAccountDone'
		)
)
const DeleteAccountMailSentPage = lazyPage(
	() =>
		import(
			'pages/auth/pages/deleteAccount/DeleteAccountMailSent/DeleteAccountMailSent'
		)
)

export default function getAuthRouter() {
	return <Route key="1235">{getAuthRoutes()}</Route>
}

function getAuthRoutes() {
	return (
		<Route>
			<Route path={AppUrls.Login().url} element={<LoginPage />} />
			<Route path={AppUrls.MagicLink().url} element={<MagicLinkPage />} />
			<Route
				path={AppUrls.RecoveryStart().url}
				element={<RecoverStartPage />}
			/>
			<Route
				path={AppUrls.RecoveryCheck('').urlShort}
				element={<RecoveryCheckPage />}
			/>
			<Route
				path={AppUrls.RecoverySet('').urlShort}
				element={<RecoverySetPage />}
			/>
			<Route
				path={AppUrls.RecoveryFinish().url}
				element={<RecoveryFinishPage />}
			/>
			<Route
				path="*"
				element={
					<ErrorPage
						errorCode={404}
						redirectUrl={AppUrls.Login().url}
					/>
				}
			/>
			<Route
				path={AppUrls.DeleteAccount().url}
				element={<DeleteAccountPage />}
			/>
			<Route
				path={
					AppUrls.DeleteAccountConfirm(
						':' + RouterVarNames.DeleteAccountCode
					).url
				}
				element={<DeleteAccountConfirmPage />}
			/>
			<Route
				path={AppUrls.DeleteAccountDone().url}
				element={<DeleteAccountDonePage />}
			/>
			<Route
				path={AppUrls.DeleteAccountMailSent().url}
				element={<DeleteAccountMailSentPage />}
			/>
		</Route>
	)
}
